import React from "react";
import { LogoColorSVG } from "../../assets/svg/SvgIcons";
import { APP_NAME, APP_TAGLINE } from "../../constants/webapp";
import { secondaryColor } from "../../theme/Theme";

export const LandingPage = () => {
  return (
    <div className="flexCenter flexColumn" style={{ height: "100vh" }}>
      <img
        src={LogoColorSVG}
        style={{ width: 100, height: 100, marginRight: 20 }}
      />
      <div style={{ lineHeight: 0.5 }} className="textCenter">
        <h1 style={{ color: secondaryColor }}>{APP_NAME}</h1>
        <p className="font12" style={{}}>
          {APP_TAGLINE}
        </p>
      </div>
    </div>
  );
};
